import {view} from '@sail/ui/deprecated';
import {useCallback, useEffect, useRef} from 'react';

export type InlineLinkProps = {
  href: string | null;
  innerText: string | null;
  parentInnerText: string | null;
};

export const InlineLinkClickHandler = ({
  onClick,
  children,
}: {
  onClick: (props: InlineLinkProps) => boolean | void;
  children: React.ReactNode;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const inlineLinkCallback = useCallback(
    (e?: MouseEvent) => {
      const target = e?.currentTarget as HTMLAnchorElement;
      const linkHref = target.getAttribute('href');
      const linkText = target.innerText;
      const parentText = target.parentElement?.innerText || '';

      onClick({
        href: linkHref,
        innerText: linkText,
        parentInnerText: parentText,
      });
    },
    [onClick],
  );

  useEffect(() => {
    const links = ref.current?.getElementsByTagName('a');
    if (links) {
      Array.from(links).forEach((link: HTMLAnchorElement) => {
        link.addEventListener('click', inlineLinkCallback);
      });
    }

    return () => {
      if (links) {
        Array.from(links).forEach((link: HTMLAnchorElement) => {
          link.removeEventListener('click', inlineLinkCallback);
        });
      }
    };
  }, [ref, inlineLinkCallback]);

  return <view.div ref={ref}>{children}</view.div>;
};
